import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import SolarChartLinear from "../icons/SolarChartLinear";
import SideBarItemList from "./SideBarItemList.jsx";
 
import SolarSettingsLinear from "../icons/SolarSettingsLinear.jsx";
import SolarBoxLinear from "../icons/SolarBoxLinear.jsx";
import SolarBoxMinimalisticLinear from "../icons/SolarBoxMinimalisticLinear";
import SolarLayersMinimalisticLinear from "../icons/SolarLayersMinimalisticLinear";
import SolarToolboxLinear from "../icons/SolarToolboxLinear";
import SolarChecklistMinimalisticLinear from "../icons/SolarChecklistMinimalisticLinear.jsx";
import SolarUsersGroupRoundedLinear from "../icons/SolarUsersGroupRoundedLinear.jsx";
import SolarUserLinear from "../icons/SolarUserLinear.jsx";
import SolarSunriseLinear from "../icons/SolarSunriseLinear.jsx";
import SolarWalletMoneyLinear from "../icons/SolarWalletMoneyLinear";
import SideBarWarehouses from "./SideBarWarehouses.jsx";
import SideBarTools from "./SideBarTools";
import SolarBillListLinear from "../icons/SolarBillListLinear.jsx";
import SolarClipboardCheckOutline from "../icons/SolarClipboardCheckOutline.jsx";
import SolarChart2Linear from "../icons/SolarChart2Linear";
import SolarTuningLineDuotone from "../icons/SolarTuningLineDuotone.jsx";
import SolarDocumentTextLinear from "../icons/SolarDocumentTextLinear";
import SolarWidget4Linear from "../icons/SolarWidget4Linear";
import { useAuth } from "context/AuthContext.jsx";
import { useSettings } from "context/SettingsContext";
import useSettingsParams from "hooks/useSettingsParams";
import { hasUserAccess, canViewSales } from "utils/helpers/access/hasUserAccess";
  
const SideBarUl = ({ setMobSideBarShow, WarehouseNameOffcanvas = null }) => {

    const { t } = useTranslation();
    const { auth } = useAuth();
    const { getSettings } = useSettings();
    const params = useSettingsParams();
    const location = useLocation();
    const [showCreateTeam, setShowCreateTeam] = useState(false);
    const [showCreateCustom, setShowCreateCustom] = useState(false);
    const canViewReports = hasUserAccess(auth?.user, 'reportsView');
    const canViewSalesMenu = canViewSales(auth?.user);
    const canCreateTeam = hasUserAccess(auth?.user, 'teamsEdit');
    const isAdmin = !!auth?.user?.admin;
    const canViewTasks = !!params.tasksModule;
    const customWarehousesEnabled = Boolean(params.customWarehouses);
    
    const handleClickOnSideBar = (e) => {
        if (e?.target?.classList?.contains('hide-sidebar'))
            setMobSideBarShow(false);
    }

    return ( 
        <>
        <ul className="pc-navbar d-block"
            onClick={handleClickOnSideBar}>
                
    
                <li className={`pc-item  ${location.pathname.startsWith('/dashboard') ? 'active' : ''}`} >
                    <Link className="pc-link hide-sidebar"
                        to="/">
                        <span className="pc-micon pc-micon--dashboard">
                            <SolarChartLinear/> 
                        </span>
                        <span className="pc-mtext">{t('SideBarUl.itemDashboard')}</span>
                    </Link>
                </li>

                {canViewTasks && (
                <li className={`pc-item  ${location.pathname.startsWith('/tasks') ? 'active' : ''}`} >
                    <Link className="pc-link hide-sidebar"
                        to="/tasks">
                        <span className="pc-micon pc-micon--tasks">
                            <SolarClipboardCheckOutline/>
                        </span>
                        <span className="pc-mtext">{t('SideBarUl.itemTasks')}</span>
                    </Link>
                </li>
                )}

                <SideBarItemList
                    title={t('SideBarUl.itemClients')}
                    icon={(<SolarUsersGroupRoundedLinear/>)}
                    iconClass="pc-micon--clients"
                    itemsList={[
                        {label: t('SideBarUl.itemLeads'), to: '/leads', startsWith: '/leads', icon: <SolarChecklistMinimalisticLinear />},
                        {label: t('SideBarUl.itemClientsBase'), to: '/clients', startsWith: '/clients', icon: <SolarUsersGroupRoundedLinear />},
                        {label: t('SideBarUl.itemCustomersBase'), to: '/customers', startsWith: '/customers', icon: <SolarUserLinear />},
                    ]}/>

                <SideBarItemList
                    title={t('SideBarUl.itemOrders')}
                    icon={(<SolarSunriseLinear/>)}
                    iconClass="pc-micon--objects"
                    itemsList={[
                        {label: t('SideBarUl.itemObjects'), to: '/objects', startsWith: '/objects', icon: <SolarSunriseLinear />},
                        ...(canViewSalesMenu
                            ? [
                                {label: t('SideBarUl.itemSales'), to: '/sales', startsWith: '/sales', icon: <SolarWalletMoneyLinear />},
                                {label: t('SideBarUl.itemServiceSales'), to: '/service-sales', startsWith: '/service-sales', icon: <SolarToolboxLinear />},
                            ]
                            : []),
                    ]}/>

                <SideBarItemList
                    title={t('SideBarUl.itemCatalog')}
                    icon={(<SolarBoxLinear/>)}
                    iconClass="pc-micon--catalog"
                    itemsList={[
                        {label: t('SideBarUl.itemProducts'), to: '/products', icon: <SolarBoxMinimalisticLinear />},
                        {label: t('SideBarUl.itemSets'), to: '/sets', icon: <SolarLayersMinimalisticLinear />},
                        {label: t('SideBarUl.itemServices'), to: '/services', icon: <SolarToolboxLinear />},
                    ]}/>

                <SideBarWarehouses
                    onOpenCreateTeam={() => setShowCreateTeam(true)}
                    onOpenCreateCustom={() => setShowCreateCustom(true)}
                />

                <SideBarTools />

                {canViewReports &&
                (<SideBarItemList
                    title={t('SideBarUl.itemReposts')}
                    icon={(<SolarBillListLinear/>)}
                    iconClass="pc-micon--reports"
                    itemsList={[ 
                        {label: t('SideBarUl.itemRepostsObjects'), to: '/reports/objects', icon: <SolarChart2Linear />},
                        {label: t('SideBarUl.itemRepostsTeams'), to: '/reports/teams', icon: <SolarUsersGroupRoundedLinear />},
                        {label: t('SideBarUl.itemRepostsUsers'), to: '/reports/users', icon: <SolarUserLinear />},
                    ]}/>)}

                {isAdmin &&
                (<SideBarItemList
                    title={t('SideBarUl.itemAdmin')}
                    icon={(<SolarSettingsLinear/>)}
                    iconClass="pc-micon--admin"
                    itemsList={[
                        {label: t('SideBarUl.itemSettings'), to: '/settings', icon: <SolarSettingsLinear />},
                        {label: t('SideBarUl.itemBusinessMode'), to: '/settings/business-mode', icon: <SolarTuningLineDuotone />},
                        {label: t('SideBarUl.itemUsers'), to: '/users', icon: <SolarUsersGroupRoundedLinear />},
                        {
                            label: t('SideBarUl.itemTemplates'),
                            icon: <SolarDocumentTextLinear />,
                            children: [
                                {label: t('SideBarUl.itemProposal'), to: '/proposal'},
                                {label: t('SideBarUl.itemDocuments'), to: '/documents'},
                            ],
                        },
                        {
                            label: t('SideBarUl.itemIntegrations'),
                            icon: <SolarWidget4Linear />,
                            children: [
                                {label: t('SideBarUl.itemTelegramBot'), to: '/settings/telegram-bot'},
                                {label: t('SideBarUl.itemSourceLeads'), to: '/settings/source-leads'},
                                {label: t('SideBarUl.itemApiKeys'), to: '/settings/api-keys'},
                                {label: t('SideBarUl.itemApiDocs'), to: '/settings/api-docs'},
                            ],
                        },
                    ]}/>)}
        </ul>
        {canCreateTeam && WarehouseNameOffcanvas && (
            <WarehouseNameOffcanvas
                kind="team"
                mode="create"
                show={showCreateTeam}
                setShow={setShowCreateTeam}
                onSuccess={getSettings}
            />
        )}
        {canCreateTeam && customWarehousesEnabled && WarehouseNameOffcanvas && (
            <WarehouseNameOffcanvas
                kind="custom"
                mode="create"
                show={showCreateCustom}
                setShow={setShowCreateCustom}
                onSuccess={getSettings}
            />
        )}
        </>
    )
}

export default SideBarUl;